export default __webpack_public_path__ + "static/media/join-team.5fd6b568.png";